/**
 * Shared AJAX grid filtering for portfolio / news hubs.
 */
let activeGridFilterRequest = null;
let activeLoadingTimer = null;
let activeSwapTimer = null;
let activeFilterRequestId = 0;
let activeFilterContext = null;

const FILTER_LOADER_SELECTOR =
	"#multi-filter-wrapper .viewing-wrapper, #filter-select-wrapper .viewing-wrapper";
const LOAD_MORE_SELECTOR = ".hub-filter-load-more";
const DEFAULT_LOAD_MORE_LABEL = "Load more";
const DEFAULT_LOAD_MORE_LOADING_LABEL = "Loading…";

// Captured when filtering.js loads (before footer scripts may overwrite ldc_ajax_object).
const hubAjaxObjectSnapshot =
	window.ldc_ajax_object && typeof window.ldc_ajax_object === "object"
		? Object.assign({}, window.ldc_ajax_object, {
				hub_filter:
					window.ldc_ajax_object.hub_filter &&
					typeof window.ldc_ajax_object.hub_filter === "object"
						? Object.assign({}, window.ldc_ajax_object.hub_filter)
						: undefined,
		  })
		: null;

function getHubAjaxObject() {
	return hubAjaxObjectSnapshot || window.ldc_ajax_object || {};
}

function getHubFilterConfig() {
	var cfg = getHubAjaxObject().hub_filter || {};

	return {
		loadMoreEnabled: cfg.loadMoreEnabled === true,
		perPage: cfg.fetchAll ? 0 : parseInt(cfg.perPage, 10) || 24,
		fetchAll: cfg.fetchAll === true,
		loadMoreLabel: getLoadMoreLabelFromConfig(cfg),
	};
}

function getLoadMoreLabelFromConfig(cfg) {
	var label =
		cfg && typeof cfg.loadMoreLabel === "string"
			? cfg.loadMoreLabel.trim()
			: "";

	return label || DEFAULT_LOAD_MORE_LABEL;
}

function getLoadMoreLabel() {
	return getHubFilterConfig().loadMoreLabel;
}

function getHubPage() {
	return jQuery(".page");
}

function isHubFilteredMode() {
	return getHubPage().hasClass("is-filtered");
}

export function enterHubFilteredMode() {
	getHubPage().addClass("is-filtered");
}

export function exitHubFilteredMode() {
	activeFilterContext = null;
	getHubPage().removeClass("is-filtered");
	jQuery(".grid-for-filtering").each(function() {
		hideFilterLoadMore(jQuery(this));
	});
	jQuery(".pagination").removeClass("is-hidden");
}

function getFilterLoaderHost() {
	return jQuery(FILTER_LOADER_SELECTOR).first();
}

function getFilterLoaderAnchor($host) {
	var $selectLabel = $host.find(".select").first();
	if ($selectLabel.length) {
		return $selectLabel;
	}
	return $host.find("#filter-select, select[id^='filter-select']").first();
}

function ensureFilterLoader() {
	var $host = getFilterLoaderHost();
	if (!$host.length) {
		return null;
	}
	if (!$host.find(".hub-filter-loader").length) {
		var $anchor = getFilterLoaderAnchor($host);
		if ($anchor.length) {
			$anchor.after(
				'<span class="hub-filter-loader" aria-hidden="true"></span>'
			);
		}
	}
	return $host;
}

function getLoadMoreWrapper($grid) {
	var $wrapper = $grid.siblings(LOAD_MORE_SELECTOR);
	if (!$wrapper.length) {
		$wrapper = jQuery(
			'<div class="hub-filter-load-more is-hidden">' +
				'<button type="button" class="button hub-filter-load-more__btn">' +
				jQuery("<span>").text(getLoadMoreLabel()).html() +
				"</button>" +
			"</div>"
		);
		$grid.after($wrapper);
	}
	return $wrapper;
}

function setLoadMoreState($grid, hasMore, isLoading) {
	var config = getHubFilterConfig();
	var loadMoreLabel = config.loadMoreLabel;

	if (!isHubFilteredMode() || !config.loadMoreEnabled || config.fetchAll) {
		hideFilterLoadMore($grid);
		return;
	}

	var $wrapper = getLoadMoreWrapper($grid);
	var $btn = $wrapper.find(".hub-filter-load-more__btn");

	if (!hasMore) {
		$wrapper.addClass("is-hidden");
		$btn.prop("disabled", false).text(loadMoreLabel);
		return;
	}

	$wrapper.removeClass("is-hidden");
	if (isLoading) {
		$btn.prop("disabled", true).text(DEFAULT_LOAD_MORE_LOADING_LABEL);
	} else {
		$btn.prop("disabled", false).text(loadMoreLabel);
	}
}

function hideFilterLoadMore($grid) {
	if ($grid && $grid.length) {
		$grid.siblings(LOAD_MORE_SELECTOR).addClass("is-hidden");
	}
}

function parseFilterResponse(response) {
	var data;

	try {
		data = JSON.parse(response);
	} catch (error) {
		return {
			posts: [],
			has_more: false,
			page: 1,
		};
	}

	if (Array.isArray(data)) {
		return {
			posts: data,
			has_more: false,
			page: 1,
		};
	}

	return {
		posts: data.posts || [],
		has_more: !!data.has_more,
		page: data.page || 1,
		per_page: parseInt(data.per_page, 10) || 0,
		load_more_enabled: data.load_more_enabled !== false,
		matched_total: parseInt(data.matched_total, 10) || 0,
		unfiltered_match_count: parseInt(data.unfiltered_match_count, 10) || 0,
		suggestions: Array.isArray(data.suggestions) ? data.suggestions : [],
		error: data.error || "",
		message: data.message || "",
	};
}

/**
 * Apply server-side has_more; do not re-clamp using a mismatched client perPage.
 */
function normalizeFilterResult(result) {
	var config = getHubFilterConfig();
	var posts = result.posts || [];
	var hasMore = !!result.has_more;
	var loadMoreEnabled =
		result.load_more_enabled !== false && config.loadMoreEnabled;

	if (!loadMoreEnabled || config.fetchAll || !posts.length) {
		hasMore = false;
	}

	return {
		posts: posts,
		has_more: hasMore,
		page: result.page || 1,
		per_page: result.per_page || config.perPage,
		matched_total: result.matched_total || 0,
		unfiltered_match_count: result.unfiltered_match_count || 0,
		suggestions: result.suggestions || [],
		error: result.error || "",
		message: result.message || "",
	};
}

function getExistingGridPostKeys($grid) {
	var keys = {};

	$grid.find(".post__card").each(function() {
		var $card = jQuery(this);
		var id = $card.data("postId");
		var link = $card.find("a.post-inner").attr("href");

		if (id) {
			keys[String(id)] = true;
		}
		if (link) {
			keys[link] = true;
		}
	});

	return keys;
}

function filterNewGridPosts(posts, existingKeys) {
	return posts.filter(function(post) {
		if (post.id && existingKeys[String(post.id)]) {
			return false;
		}
		if (post.link && existingKeys[post.link]) {
			return false;
		}
		return true;
	});
}

function applyInstantClientFilter(filterby, value) {
	jQuery(".grid-for-filtering .post__card").removeClass("is-hidden");
	jQuery(".grid-for-filtering .post__card").each(function() {
		var $card = jQuery(this);
		var terms = $card.data(filterby);

		if (typeof terms !== "string" && typeof terms !== "number") {
			$card.addClass("is-hidden");
			return;
		}

		var termList = String(terms).trim().split(/\s+/);
		if (termList.indexOf(value) === -1) {
			$card.addClass("is-hidden");
		}
	});
}

function cancelPendingGridSwap() {
	if (activeSwapTimer) {
		clearTimeout(activeSwapTimer);
		activeSwapTimer = null;
	}
}

function buildGridHtml(posts, cardTemplate, emptyHtml) {
	if (!posts.length) {
		if (emptyHtml === "") {
			return "";
		}
		return emptyHtml || '<p class="grid-for-filtering__empty">No results found for this filter.</p>';
	}
	return posts.map(function(post) {
		return cardTemplate(post);
	}).join("");
}

function renderGridPosts($grid, posts, cardTemplate, requestId, hasMore) {
	if (requestId !== activeFilterRequestId) {
		return;
	}

	cancelPendingGridSwap();
	$grid.removeClass("is-fading-out is-swapping");

	enterHubFilteredMode();

	var html = buildGridHtml(
		posts,
		cardTemplate,
		activeFilterContext && activeFilterContext.emptyHtml
	);
	$grid.addClass("is-swapping");
	$grid.html(html);

	activeSwapTimer = window.setTimeout(function() {
		if (requestId !== activeFilterRequestId) {
			return;
		}
		activeSwapTimer = null;
		$grid.removeClass("is-swapping");
	}, 360);

	setLoadMoreState($grid, hasMore, false);
}

function appendGridPosts($grid, posts, cardTemplate, requestId, hasMore) {
	if (requestId !== activeFilterRequestId) {
		return;
	}

	var existingKeys = getExistingGridPostKeys($grid);
	var newPosts = filterNewGridPosts(posts, existingKeys);

	if (!newPosts.length) {
		setLoadMoreState($grid, false, false);
		return;
	}

	var html = newPosts.map(function(post) {
		return cardTemplate(post);
	}).join("");
	var $cards = jQuery(html);
	$grid.addClass("is-swapping");
	$grid.append($cards);

	activeSwapTimer = window.setTimeout(function() {
		if (requestId !== activeFilterRequestId) {
			return;
		}
		activeSwapTimer = null;
		$grid.removeClass("is-swapping");
	}, 360);

	setLoadMoreState($grid, hasMore, false);
}

function decodeHubEntities(value) {
	var str = String(value == null ? "" : value);

	if (str.indexOf("&") === -1) {
		return str;
	}

	var textarea = document.createElement("textarea");
	textarea.innerHTML = str;

	return textarea.value;
}

function escapeHubHtml(value) {
	return decodeHubEntities(value)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
}

function escapeHubAttr(value) {
	return escapeHubHtml(value).replace(/`/g, "&#96;");
}

function portfolioCardTemplate(post) {
	var title = escapeHubHtml(post.title);
	var excerpt = escapeHubHtml(post.excerpt);
	var link = escapeHubAttr(post.link);
	var img = escapeHubAttr(post.img);

	return (
		'<div class="post__card" data-post-id="' + escapeHubAttr(post.id) + '">' +
		'<a href="' + link + '" class="post-inner">' +
		'<div class="image" style="background-image: url(' + img + ');"></div>' +
		'<div class="content">' +
		'<h4 class="content__title">' + title + "</h4>" +
		'<p class="content__copy">' + excerpt + "</p>" +
		"</div></a></div>"
	);
}

function newsCardTemplate(post) {
	var title = escapeHubHtml(post.title);
	var date = escapeHubHtml(post.date);
	var link = escapeHubAttr(post.link);
	var img = escapeHubAttr(post.img);

	return (
		'<div class="post__card" data-post-id="' + escapeHubAttr(post.id) + '">' +
		'<a href="' + link + '" class="post-inner">' +
		'<div class="image" style="background-image: url(' + img + ');"></div>' +
		'<div class="content">' +
		'<p class="content__date">' + date + "</p>" +
		'<h4 class="content__title">' + title + "</h4>" +
		"</div></a></div>"
	);
}

function clearLoadingState($grid) {
	if (activeLoadingTimer) {
		clearTimeout(activeLoadingTimer);
		activeLoadingTimer = null;
	}
	clearFilterLoader();
	if ($grid && $grid.length) {
		$grid.removeClass("loading");
	}
}

function clearFilterLoader() {
	jQuery(FILTER_LOADER_SELECTOR).removeClass("is-filter-loading");
}

function showFilterLoader() {
	var $loaderHost = ensureFilterLoader();
	if ($loaderHost) {
		$loaderHost.addClass("is-filter-loading");
	}
}

// Live search spins its own loader inside the input, so the filter loader is
// left off for search-driven requests to avoid two spinners at once.
function scheduleLoadingState($grid, withFilterLoader = true) {
	clearLoadingState($grid);
	if (withFilterLoader) {
		showFilterLoader();
	}
	$grid.addClass("loading");
}

function scheduleLoadMoreLoadingState($grid, withFilterLoader = true) {
	if (withFilterLoader) {
		showFilterLoader();
	}
	setLoadMoreState($grid, true, true);
}

function requestFilteredGridPosts(options) {
	const {
		postType,
		term,
		taxonomy,
		$grid,
		filterby,
		value,
		cardTemplate,
		instantFilter = true,
		page = 1,
		append = false,
		searchTerm = "",
		onResult = null,
		emptyHtml,
	} = options;

	if (!$grid || !$grid.length) {
		return null;
	}

	if (!append) {
		activeFilterRequestId += 1;
	}

	const requestId = activeFilterRequestId;

	if (activeGridFilterRequest) {
		activeGridFilterRequest.abort();
		activeGridFilterRequest = null;
	}

	if (!append) {
		cancelPendingGridSwap();

		if (instantFilter && filterby && value) {
			applyInstantClientFilter(filterby, value);
		}

		scheduleLoadingState($grid, !searchTerm);
	} else {
		scheduleLoadMoreLoadingState($grid, !searchTerm);
	}

	activeFilterContext = {
		postType: postType,
		term: term,
		taxonomy: taxonomy,
		filterby: filterby,
		value: value,
		$grid: $grid,
		cardTemplate: cardTemplate,
		page: page,
		searchTerm: searchTerm || "",
		onResult: typeof onResult === "function" ? onResult : null,
		emptyHtml: emptyHtml,
	};

	activeGridFilterRequest = jQuery.ajax({
		type: "POST",
		url: getHubAjaxObject().ajax_url,
		dataType: "html",
		data: {
			action: "get_ajax_grid_posts",
			security: getHubAjaxObject().security,
			postType: postType,
			term: term,
			taxonomy: taxonomy,
			page: page,
			searchTerm: searchTerm || "",
		},
		cache: false,
		success: function(response) {
			if (requestId !== activeFilterRequestId) {
				return;
			}

			var result = normalizeFilterResult(parseFilterResponse(response));

			activeFilterContext.page = result.page;

			if (append) {
				appendGridPosts(
					$grid,
					result.posts,
					cardTemplate,
					requestId,
					result.has_more
				);
			} else {
				renderGridPosts(
					$grid,
					result.posts,
					cardTemplate,
					requestId,
					result.has_more
				);
			}

			if (typeof onResult === "function") {
				onResult(result, { append: append });
			}
		},
		error: function(xhr, status) {
			if (status === "abort" || requestId !== activeFilterRequestId) {
				return;
			}

			if (append) {
				setLoadMoreState($grid, true, false);
				return;
			}

			hideFilterLoadMore($grid);
			$grid.html(
				'<div class="error-message">Sorry, there was an error loading the results.</div>'
			);
		},
		complete: function() {
			if (requestId !== activeFilterRequestId) {
				return;
			}
			clearLoadingState($grid);
			activeGridFilterRequest = null;
		},
	});

	return activeGridFilterRequest;
}

export function fetchFilteredGridPosts(options) {
	return requestFilteredGridPosts(
		Object.assign({}, options, {
			page: 1,
			append: false,
		})
	);
}

jQuery(document).on("click", ".hub-filter-load-more__btn", function() {
	if (!activeFilterContext || !isHubFilteredMode()) {
		return;
	}

	var config = getHubFilterConfig();
	if (!config.loadMoreEnabled || config.fetchAll) {
		return;
	}

	var ctx = activeFilterContext;

	var hasSearch = !!(ctx.searchTerm && ctx.searchTerm.trim().length >= 2);
	if ((!ctx.term || !ctx.taxonomy || ctx.term === "all") && !hasSearch) {
		hideFilterLoadMore(ctx.$grid);
		return;
	}

	requestFilteredGridPosts({
		postType: ctx.postType,
		term: ctx.term,
		taxonomy: ctx.taxonomy,
		filterby: ctx.filterby,
		value: ctx.value,
		$grid: ctx.$grid,
		cardTemplate: ctx.cardTemplate,
		searchTerm: ctx.searchTerm || "",
		onResult: ctx.onResult,
		emptyHtml: ctx.emptyHtml,
		instantFilter: false,
		skipUrlUpdate: true,
		page: ctx.page + 1,
		append: true,
	});
});

export { applyInstantClientFilter, portfolioCardTemplate, newsCardTemplate };
